// This is the modal component that handles importing RdSAP data.

import { Component, OnInit } from '@angular/core';
import { FileUploader } from 'ng2-file-upload';
import { IHSXmlHandlingService } from '../../../services/rdsap-api/iHSXmlHandling.service';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';

@Component({
  selector: 'app-create-rdsap-survey-modal',
  templateUrl: './create-rdsap-survey-modal.component.html',
})
export class CreateRdSAPSurveyModalComponent implements OnInit {
  hasData = false;
  hasError = false;
  assetId: string;
  RdSAPDetails: any = {};
  xmlData = '';
  attachmentDetails = [];
  uploadKey = '';
  uploadKeyAttachment = '';
  attachmentName = '';
  attachmentNotes = '';
  activeSurvey = '';
  surveyStatusEnum = [
    { Id: 1, Name: 'Pending' },
    { Id: 2, Name: 'Complete' },
    { Id: 3, Name: 'Awaiting Approval' },
    { Id: 4, Name: 'new' }
  ];
  survey = {};
  uploader: FileUploader;
  fileUploadUrl: string;
  headerData: any;
  fileUploadRequest: any;
  fileUploadIdFromClient: string;

  constructor(
    private xmlHandlingService: IHSXmlHandlingService,
    public activeModal: NgbActiveModal,
  ) {
    this.assetId = ''; // set the assetId
  }

  ngOnInit() {
    this.initializeFileUpload();
  }

  initializeFileUpload() {
    this.fileUploadIdFromClient = crypto.randomUUID();
    this.fileUploadUrl = this.buildFileUploadUrl();

    const uploaderOptions = {
      url: this.fileUploadUrl,
      headers: [{ name: 'X-XSRF-TOKEN', value: 'abp.xsrf.token' }]
    };

    this.uploader = new FileUploader(uploaderOptions);
    this.configureFileUploader();
  }

  configureFileUploader() {
    this.uploader.onWhenAddingFileFailed = (item, filter, options) => {
      console.info('onWhenAddingFileFailed', item, filter, options);
    };

    this.uploader.onAfterAddingFile = (fileItem) => {
      fileItem.upload();
    };

    // Add the filters property to the uploader options
    this.uploader.options.filters = [{
      name: 'customFilter',
      fn: (item, options) => this.uploader.queue.length < 10
    }];

    this.uploader.onAfterAddingAll = (addedFileItems) => {
      console.info('onAfterAddingAll', addedFileItems);
    };

    this.uploader.onBeforeUploadItem = function (item) {
      console.info('onBeforeUploadItem', item);
    };
    this.uploader.onProgressItem = function (fileItem, progress) {
      console.info('onProgressItem', fileItem, progress);
    };
    this.uploader.onProgressAll = function (progress) {
      console.info('onProgressAll', progress);
    };
    this.uploader.onSuccessItem = function (fileItem, response, status, headers) {
      console.info('onSuccessItem', fileItem, response, status, headers);
    };
    this.uploader.onErrorItem = function (fileItem, response, status, headers) {
      console.info('onErrorItem', fileItem, response, status, headers);
    };
    this.uploader.onCancelItem = function (fileItem, response, status, headers) {
      console.info('onCancelItem', fileItem, response, status, headers);
    };
    this.uploader.onCompleteItem = function (fileItem, response, status, headers) {

      console.info('onCompleteItem', fileItem, response, status, headers);
      this.fileUploadRequest = response;
    };

    this.uploader.onCompleteItem = (fileItem, response, status, headers) => {
      console.info('onCompleteItem', fileItem, response, status, headers);
      this.fileUploadRequest = response;
      this.xmlHandlingService.extractRdSapDataSetDtoFromRdSapXmlFile({fileUploadId: this.fileUploadRequest.id})
        .subscribe(rdSapDataSet => {
          if (rdSapDataSet) {
            this.RdSAPDetails = rdSapDataSet;
            this.hasData = true;
            this.hasError = false;
          } else {
            this.hasError = true;
          }
        });
    };
  }

  buildFileUploadUrl(): string {
    const params = new URLSearchParams({
      fileUploadIdFromClient: this.fileUploadIdFromClient,
      fileUploadRequestType: 'file',
    });
    return `/api/fileUploadRequest/UploadFilesAndGetFileUploadRequest?${params}`;
  }

  save() {
    if (!this.hasData) return;

    this.RdSAPDetails.assetId = this.assetId;
    this.RdSAPDetails.dataSetType = 1;
    console.log(this.RdSAPDetails);
    this.activeModal.close(this.RdSAPDetails); // Close the dialog and optionally pass data back
  }

  cancel() {
    this.activeModal.close(); // Close the dialog without passing any data
  }
}
